import * as React from 'react'
function SvgUpload(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 26l.15.005c1.041.077 1.85.94 1.85 1.993V34c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2v-6.002C4 26.887 4.895 26 6 26l.15.005c1.041.077 1.85.94 1.85 1.993V32h24v-4.002c0-1.1.895-1.998 2-1.998zM18.6 4.6c.8-.8 2-.8 2.8 0l9.98 9.98a2 2 0 01.004 2.836l.015-.017-.11.101a2.002 2.002 0 01-2.574.005l-.127-.117L22 10.8v15.193A2.005 2.005 0 0120 28l-.15-.006a1.999 1.999 0 01-1.85-2V10.8l-6.588 6.588a1.996 1.996 0 01-2.828-.004l.016.015-.1-.11a2.008 2.008 0 01.003-2.582l.118-.128L18.6 4.6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgUpload
